/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Other_RssInputs */

const en_footer_other_rss = /** @type {(inputs: Footer_Other_RssInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RSS`)
};

/**
* | output |
* | --- |
* | "RSS" |
*
* @param {Footer_Other_RssInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const footer_other_rss = /** @type {((inputs?: Footer_Other_RssInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Other_RssInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_footer_other_rss(inputs)
});